import { useEffect } from 'react';

export const useGDLIBInit = (cb: () => void, cleanUpCb?: () => void): void => {
  useEffect((): any => {
    if (window.__gdlib) {
      cb();
    } else {
      const listener = (e: MessageEvent): void => {
        if (e.data?.type === 'GD_ROOT_INIT') {
          cb();
        }
      };

      window.addEventListener('message', listener);

      return () => {
        cleanUpCb?.();
        window.removeEventListener('message', listener);
      };
    }
  }, [cb]);
};
